import React from "react";

function HeroSection() {
  return (
    <div
      id="hero-section"
      className="w-full h-screen bg-[var(--pmBackground)] top-0 left-0 flex flex-col items-end overflow-y-auto p-4 md:pt-[10rem] md:pr-[10rem] lg:pt-[15rem] lg:pr-[15rem] m-0"
    >
      <div className="w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/4 aspect-square rounded-full overflow-hidden shadow-[-12px_-12px_55px_rgba(0,0,0,0.5)]">
        <img
          src="/media/Me.jpg"
          className="h-full w-full object-cover"
          alt="Hero"
        />
      </div>
    </div>
  );
}

export default HeroSection;
